import api from "../interceptor/interceptor";

const LiveTrackService = {
    async getVehicles(startDate, endDate) {
        try {
            const response = await api.post('/analytics/api/v1/fleet/get_all_groups_vehicles',
                {
                    "fromdate": startDate,
                    "todate": endDate,
                    "datetype": "month"
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Apitype': 'safetyanalysis'
                    }
                })
            const vehicles = response.data.data.map((group) => [...group.vehicles]);
            return vehicles.flat();
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    },
    async getLiveVehicles() {
        try {
            const response = await api.post('/api/websocket/gettoken',
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
            return response.data.wstoken;
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    },
    async intializeWebSocket(token) {
        const ws = await new WebSocket(
            "wss://2eogxn9wae.execute-api.ap-south-1.amazonaws.com/dev?token=" + token,
        );
        return ws;
    }
}


export default LiveTrackService;

